// Google Adsense -------------------------------------------------------------

import {browserGetBrowserWidth} from "./browser.js";

const ADSENSE_MAXIMUM_WIDTH = 320;


function adsensePush()
{
    window.adsbygoogle = window.adsbygoogle || [];
    window.adsbygoogle.push({});
}

function adsensePushFullAds()
{
    let ads = document.getElementsByClassName("fullAdWrapper");
    [].forEach.call(ads, (ad) =>
    {
        adsensePush();
    });
}


function adsenseAddAndPush(parent, width = 0)
{

    // "Posters footer" ad
    let template = "<ins class='adsbygoogle'"
            + " style='display:block'"
            + " data-ad-client='ca-pub-9941509058397179'"
            + " data-ad-slot='4983453271'";

    if ((width !== 0) && (browserGetBrowserWidth() > ADSENSE_MAXIMUM_WIDTH))
    {
        template += " data-ad-format='vertical'";
    } else
    {
        template += " data-ad-format='auto'";
    }

    template += " data-full-width-responsive='true'></ins>";

    if (width !== 0)
    {
        let wrapper;
        wrapper = document.createElement('div');
        wrapper.setAttribute("class", "adWrapper mainItem");
        wrapper.innerHTML = template;
        wrapper.style.width = width + "px";
        wrapper.style.minHeight = "320px";
        wrapper.style.textAlign = "center";
        parent.appendChild(wrapper);
    } else
    {
        parent.innerHTML = template;
    }

    let ad = parent.getElementsByClassName('adsbygoogle')[0];
    adsenseObserver(ad);

    adsensePush();
}

function asdenseCallback(mutations, observer)
{
    for (let mutation of mutations)
    {
        if (mutation.type === 'attributes')
        {
            if (mutation.attributeName === 'data-ad-status')
            {
                if (mutation.target.dataset.adStatus === 'unfilled')
                {
                    mutation.target.parentElement.style.display = 'none';
                }
                observer.disconnect();
            }
        }
    }
}

function adsenseObserver(ad)
{
    let observer = new MutationObserver(asdenseCallback);

    observer.observe(ad, {attributes: true});
}

export {ADSENSE_MAXIMUM_WIDTH, adsenseAddAndPush, adsensePushFullAds}


